import "./carousel-timeline.scss";
document.addEventListener('DOMContentLoaded', function () {
	const timeline_sliders = document.querySelectorAll('.wp-block-unity-blocks-carousel-timeline .slider');

	timeline_sliders.forEach(slider => {
		const slides = slider.querySelectorAll('.slider_item');
		let max_header_height = 0;

		slides.forEach(slide => {
			const header_container = slide.querySelector('.header_container');
			if (header_container) {
				const style = window.getComputedStyle(header_container);
				const paddingTop = parseFloat(style.paddingTop) || 0;
				const paddingBottom = parseFloat(style.paddingBottom) || 0;
				const contentHeight = header_container.clientHeight - paddingTop - paddingBottom;

				if (contentHeight > max_header_height) {
					max_header_height = contentHeight;
				}
			}
		});

		if (max_header_height > 0) {
			slides.forEach(slide => {
				const header_container = slide.querySelector('.header_container');
				if (header_container) {
					header_container.style.height = `${max_header_height}px`;
				}
			});
		}
	});
});
